import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { Expandable } from 'sharedComponents/Expandable';
import AssetListComponent from '../AssetListComponent';

// eslint-disable-next-line react/display-name
const ExpandableComponent = React.memo(({
    item,
    renderExpandableTitle,
    handlePowertrainClick,
    selectedPowertrain,
    selectedAsset,
    handleSelectedItem,
    handleAssetToggle,
    isHorizontalScrollActive,
    assetGroupList,
    translate,
    allAssets,
    model,
    isLabelVisible,
    leftPanelSize
}) => {
    return (
        <Suspense fallback={<div>Loading...</div>} key={item?.assetGroupId}>
            <div data-assetgroup-id={item?.assetGroupId}>
                <Expandable
                    id={item?.assetGroupId}
                    key={item?.assetGroupId}
                    title={renderExpandableTitle(item)}
                    onClick={() => handlePowertrainClick(item)}
                    open={item?.assetGroupId === selectedPowertrain}
                    isExpanderInsideContent={true}
                    type='assetGroupV2'
                >
                    <Suspense fallback={<div>Loading...</div>} key={item?.assetGroupId}>
                        <AssetListComponent
                            assets={item?.assets}
                            key={item?.assetGroupId}
                            powertrainId={item?.assetGroupId}
                            limitSummary={item?.limitSummary}
                            selectedAsset={selectedAsset}
                            allAssets={allAssets}
                            handleSelectedItem={handleSelectedItem}
                            handleAssetToggle={handleAssetToggle}
                            showThreshold={model?.showThreshold}
                            showTrend={model?.showTrend}
                            isHorizontalScrollActive={isHorizontalScrollActive}
                            assetGroupList={assetGroupList}
                            selectedPowertrain={selectedPowertrain}
                            translate={translate}
                            isLabelVisible={isLabelVisible}
                            leftPanelSize={leftPanelSize}
                        />
                    </Suspense>
                </Expandable>
            </div>
        </Suspense>
    );
});

ExpandableComponent.propTypes = {
    item: PropTypes.object.isRequired,
    renderExpandableTitle: PropTypes.func.isRequired,
    handlePowertrainClick: PropTypes.func.isRequired,
    selectedPowertrain: PropTypes.number,
    selectedAsset: PropTypes.object,
    handleSelectedItem: PropTypes.func.isRequired,
    handleAssetToggle: PropTypes.func.isRequired,
    isHorizontalScrollActive: PropTypes.bool,
    memoizedPowertrainOverviewList: PropTypes.array,
    translate: PropTypes.func.isRequired,
    model: PropTypes.object.isRequired,
    allAssets: PropTypes.array,
    isLabelVisible: PropTypes.bool
};

export default ExpandableComponent;
